import { RdsTableData, AsgTableData, Ec2TableData } from './types';
import { ConfigApi } from '@backstage/core-plugin-api';
import {
  RdsResourceDetails,
  AsgResourceDetails,
  Ec2ResourceDetails,
} from '@internal/backstage-plugin-compute-resource-discovery-new-common';

export const mapResourcesToRdsTableData = (
  resources: RdsResourceDetails[],
): RdsTableData[] => {
  return resources.map(resource => {
    const baseData = {
      identifier: resource.identifier,
      name: resource.name,
      status: resource.status,
      engine: resource.engine,
      class: resource.class,
    };
    return baseData;
  });
};

export const mapResourcesToAsgTableData = (
  resources: AsgResourceDetails[],
): AsgTableData[] => {
  return resources.map(resource => {
    const baseData = {
      identifier: resource.identifier,
      name: resource.name,
      desired: resource.desired,
      min: resource.min,
      max: resource.max,
      instanceCount: resource.instanceCount,
      status: resource.status,
    };
    return baseData;
  });
};

export const mapResourcesToEc2TableData = (
  resources: Ec2ResourceDetails[],
): Ec2TableData[] => {
  return resources.map(resource => {
    const baseData = {
      identifier: resource.identifier,
      name: resource.name,
      state: resource.state,
      type: resource.type,
    };
    return baseData;
  });
};

export function getTeleportDocsUrl(config: ConfigApi): string | undefined {
  const techdocsUrl = config.getOptionalConfig('techdocsUrl');
  return techdocsUrl?.getOptionalString('teleport');
}
